import { LEGAL_IMPRINT_HEADING } from './0-heading.md';
import { LEGAL_IMPRINT_LEGAL_NOTICE } from './1-legal-notice.md';
import { LEGAL_IMPRINT_DISCLAIMER } from './2-disclaimer.md';


/**------------------------------------------------------
 * Imprint Template
 */
export const LEGAL_IMPRINT_TEMPLATE_DE: string = `
	${LEGAL_IMPRINT_HEADING}
	${LEGAL_IMPRINT_LEGAL_NOTICE}
	---
	${LEGAL_IMPRINT_DISCLAIMER}
`;
